import styled, { css } from 'styled-components';
import { getTypographyStyles, SEM_TYPOGRAPHY_UI_MD_CAPTION, SEM_TYPOGRAPHY_UI_MD_LABEL, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SIZE_FIXED_25, getMargins } from '@oneaudi/unified-web-common';
import { Icon } from '../icon/index.js';
export const StyledArrow = styled(Icon) `
  color: ${(props) => props.theme.sem.color.ui.foreground.icons.default};
`;
export const StyledSectionButton = styled.button `
  background-color: transparent;
  border: none;
  padding: ${SYS_SPACE_FIXED_200};
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)}
  color: ${(props) => props.theme.sem.color.ui.foreground.text.default};

  ${StyledArrow} {
    // TODO: Token missing
    transition: transform 200ms ease-in;
    transform: ${(props) => (props.open ? 'rotate(-180deg)' : 'rotate(0deg)')};

    @media (prefers-reduced-motion) {
      transition: none;
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.sem.color.ui.foreground.text.disabled};

    ${StyledArrow} {
      color: ${(props) => props.theme.sem.color.ui.foreground.icons.disabled};
    }
  }
`;
export const StyledSectionPanel = styled.div `
  display: grid;
  // Trick to animate the opening of the SectionPanel
  grid-template-rows: ${(props) => (props.open ? '1fr' : '0fr')};
  transition: 320ms grid-template-rows ease;

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;
export const StyledSectionHeading = styled.span `
  display: flex;
  margin: 0;
  border-width: ${SYS_SIZE_FIXED_25} 0 0 0;
  border-style: solid;
  border-color: ${(props) => props.theme.sem.color.ui.foreground.divider.default};

  ${StyledSectionButton}:hover:not(:disabled) {
    transition-property: color, background-color;
    // TODO: token missing;
    transition-duration: 250ms;
    transition-timing-function: ease;
    color: ${(props) => props.theme.sem.color.ui.foreground.text.interactive};

    ${StyledArrow} {
      color: ${(props) => props.theme.sem.color.ui.foreground.text.interactive};
    }
  }

  ${StyledSectionButton}:active:not(:disabled) {
    background-color: ${(props) => props.theme.cmp.color.ui.accordion.surface.pressed};
  }

  &:has(${StyledSectionButton}:active) {
    & + ${StyledSectionPanel} {
      transition-property: background-color;
      // TODO: token missing;
      transition-duration: 250ms;
      transition-timing-function: ease;
      background-color: ${(props) => props.theme.cmp.color.ui.accordion.surface.pressed};
    }
  }
`;
export const StyledAccordion = styled.div `
  border-width: 0 0 ${SYS_SIZE_FIXED_25} 0;
  border-style: solid;
  border-color: ${(props) => props.theme.sem.color.ui.foreground.divider.default};
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledPanelInner = styled.div `
  padding: ${(props) => props.open ? SYS_SPACE_FIXED_200 : `0 ${SYS_SPACE_FIXED_200}`};
  overflow: hidden;

  // TODO: finalize animation
  transition-timing-function: ease-in;
  transition-duration: 320ms;
  transition-property: transform, opacity, padding, visibility;

  @media (prefers-reduced-motion) {
    transition: none;
  }

  ${(props) => props.open
    ? css `
          padding: ${SYS_SPACE_FIXED_200};
          opacity: 1;
          visibility: visible;
        `
    : css `
          opacity: 0;
          padding: 0 ${SYS_SPACE_FIXED_200};

          visibility: hidden;
        `}
`;
export const StyledIconContainer = styled.span `
  display: flex;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledHint = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_CAPTION)}
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
`;
export const StyledLabelContainer = styled.span `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_100};
`;
//# sourceMappingURL=index.styles.js.map